import { property } from '@haventech/amorphic';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Auth0Service, CommonRoutes } from './auth0.service';
import { ModalService } from '../modal/modal.service';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';

@Component({
  moduleId: module.id,
  selector: 'auth0callback',
  templateUrl: './auth0callback.component.html',
})
export class Auth0CallbackComponent implements OnInit {
  private clientName: string;

  modalService: ModalService;
  maxFaceSell: string;
  isMobile: boolean = false;

  constructor(
    protected router: Router,
    protected windowService: WindowService,
    protected auth0Service: Auth0Service,
    protected route: ActivatedRoute
  ) {
    this.clientName = this.route.snapshot.paramMap.get('client');
  }

  ngOnInit() {
    if (this.windowService.nativeWindow.controller.isLoggedIn()) {
      this.router.navigate([CommonRoutes.ACCOUNT_CENTER]);
    } else {
      this.auth0Service.handleAuthentication(this.clientName);
    }
  }
}
